import { render, staticRenderFns } from "./Slide2.vue?vue&type=template&id=3c5bc45a&scoped=true&"
import script from "./Slide2.vue?vue&type=script&lang=ts&"
export * from "./Slide2.vue?vue&type=script&lang=ts&"
import style0 from "./Slide2.vue?vue&type=style&index=0&id=3c5bc45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5bc45a",
  null
  
)

export default component.exports